export type CsvAsStringArrays = string[][];

const ROW_SEPARATOR = '\n';
const VALUE_SEPARATOR = ',';
const STRING_DELIMITER = '"';

function escapeStringDelimiter(str: string): string {
    const stringDelimiterRegex = new RegExp(STRING_DELIMITER, 'g');
    return str.replace(stringDelimiterRegex, `${STRING_DELIMITER}${STRING_DELIMITER}`);
}

function addStringDelimiterIfNeeded(str: string): string {
    if (str.includes(STRING_DELIMITER) || str.includes(VALUE_SEPARATOR) || str.includes(ROW_SEPARATOR)) {
        return `${STRING_DELIMITER}${str}${STRING_DELIMITER}`;
    }
    return str;
}

/**
 * Escapes a single CSV value to be safely included in a CSV file.
 * Handles double quotes, commas, and newlines according to RFC 4180.
 */
function escapeCsvValue(value: string): string {
    return addStringDelimiterIfNeeded(escapeStringDelimiter(value));
}

/**
 * Converts an array of string values into a properly formatted CSV row.
 */
export function createCsvRow(row: string[]): string {
    return row.map(escapeCsvValue).join(VALUE_SEPARATOR);
}

/**
 * Converts a 2D array of strings into a complete CSV string.
 */
export function createCsvString(csvData: CsvAsStringArrays): string {
    return csvData.map(createCsvRow).join(ROW_SEPARATOR);
}
